import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  className?: string;
  text?: string;
  onClick?: () => void;
}

export const ArrowButton = ({
  className = "",
  text = "Arrow Button",
  onClick
}: Props): JSX.Element => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    if (text === "Watch Our Videos") {
      document.getElementById('examples')?.scrollIntoView({ behavior: 'smooth' });
    } else if (text === "Our Packages") {
      document.getElementById('packages')?.scrollIntoView({ behavior: 'smooth' });
    } else if (text === "Example Gallery") {
      navigate('/gallery');
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <div 
      className={`inline-flex items-center justify-center relative lg:hover:scale-110 transition-transform cursor-pointer ${className}`}
      onClick={handleClick}
      onMouseEnter={() => window.innerWidth >= 768 && setIsHovered(true)}
      onMouseLeave={() => window.innerWidth >= 768 && setIsHovered(false)}
    >
      <div className="flex items-center justify-center relative w-[229.46px] gap-3 max-md:w-[267.43px] max-md:gap-[15.6px] max-md:h-[58px]">
        <div 
          className={`
            relative w-fit mt-[-1.00px] text-[var(--fy-grey)]
            [font-family:var(--button-arrow-font-family)]
            [font-size:var(--button-arrow-font-size)]
            [font-weight:var(--button-arrow-font-weight)]
            [letter-spacing:var(--button-arrow-letter-spacing)]
            [line-height:var(--button-arrow-line-height)]
            [text-transform:var(--button-arrow-text-transform)]
            max-md:mt-[-1.13px]
            max-md:[font-family:'Amatic_SC',Helvetica]
            max-md:font-normal
            max-md:text-[38.3px]
            max-md:tracking-[1.13px]
            max-md:leading-[46.0px]
            max-md:whitespace-nowrap
          `}
        >
          {text}
        </div>
        <svg
          width="27"
          height="21"
          viewBox="0 0 27 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="relative max-md:w-[24px] max-md:h-[18px]"
        >
          <path
            d="M16.2188 1.3125L25.4062 10.5L16.2188 19.6875M25.4062 10.5H1.59375"
            stroke="#657D84"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );
}; 